import { Box, Button, Typography } from '@material-ui/core'
import { ITrack } from 'interfaces/IDashboard'
import moment from 'moment'
import { useState } from 'react'
import { IoPlayCircleOutline, IoStopCircleOutline } from 'react-icons/io5'
import { MdExpandMore } from 'react-icons/md'
import { animated } from 'react-spring'
import { AccordionDetails, Timer } from 'shared'
import { dashboardCalculateTime, formatName } from 'utils'

import { Accordion as AccordionStyled, TrackInfo, AccordionSummary, useStyles } from './styles'
import ModalPause from './ModalPause'
import ContentAccordion from './ContentAccordion'

interface Props {
  averageDuration: string
  separator: ITrack
  style?: object
  pendentOrders: number
  refreshDashboard: () => Promise<void>
  averageIdleTime?: number
}

const Accordion = ({
  separator,
  averageDuration,
  style,
  pendentOrders,
  refreshDashboard,
  averageIdleTime,
}: Props) => {
  const {
    username,
    last_work_end,
    total_orders_completed,
    last_work,
    is_paused,
    user_id,
    work_conference,
  } = separator

  const [expanded, setExpanded] = useState<boolean>(false)
  const [openModalPause, setOpenModalPause] = useState<boolean>(false)
  const classes = useStyles()
  const currentTime = moment()
  const isChecking = !!work_conference

  const isSeparating = !!last_work?.begin && !last_work?.end && !is_paused
  const formatAverageDuration = dashboardCalculateTime(Number(averageDuration))
  const initSeparation = last_work?.begin ? moment.utc(last_work.begin).local() : null
  const separationTime = initSeparation
    ? moment.duration(currentTime.diff(initSeparation)).asMilliseconds()
    : 0
  const averageTime = moment.duration(formatAverageDuration).asMilliseconds()
  const idleTimeAverage = averageIdleTime || 0

  const onClickPause = (event: any) => {
    event.preventDefault()
    setOpenModalPause(true)
  }

  const onClose = async () => {
    setOpenModalPause(false)
  }

  return (
    <animated.div style={style}>
      <AccordionStyled onClick={() => setExpanded(state => !state)} expanded={expanded}>
        <AccordionSummary expandIcon={<MdExpandMore />}>
          <Box className={classes.containerInfos}>
            <TrackInfo>
              <Typography className={classes.username}>{formatName(username)}</Typography>
            </TrackInfo>

            <Typography className={classes.text}>
              <p>
                <span className={classes.label}>Pedidos separados:</span>
                {total_orders_completed}
              </p>
            </Typography>

            <Typography>
              {isChecking && (
                <span className={classes.labelTime}>
                  Em conferência:
                  <strong style={{ color: '#99df0f' }}>
                    <Timer time={moment.utc(work_conference).local().toDate()} isHours />
                  </strong>
                </span>
              )}

              {isSeparating && (
                <span className={classes.labelTime}>
                  Em separação:
                  <strong
                    style={
                      separationTime < averageTime ? { color: '#99df0f' } : { color: '#ffbe0b' }
                    }
                  >
                    {initSeparation ? (
                      <Timer time={initSeparation.toDate()} isHours />
                    ) : (
                      <span>--:--:--</span>
                    )}
                  </strong>
                </span>
              )}

              {!isSeparating && !isChecking && last_work?.end && (
                <span className={classes.label}>
                  Última separação:
                  <strong
                    style={
                      is_paused
                        ? { color: '#A3A3A3' }
                        : idleTimeAverage > 0
                        ? { color: '#A020F0' }
                        : { color: '#ff0000' }
                    }
                  >
                    {is_paused ? (
                      '00:00:00'
                    ) : (
                      <Timer
                        time={moment.utc(last_work.end).local().toDate()}
                        stop={false}
                        isHours
                      />
                    )}
                  </strong>
                </span>
              )}
            </Typography>
          </Box>

          <Button className={classes.containerButton} onClick={onClickPause}>
            {is_paused ? (
              <IoPlayCircleOutline className={classes.iconPlayPause} />
            ) : (
              <IoStopCircleOutline className={classes.iconPlayPause} />
            )}
          </Button>
        </AccordionSummary>

        <AccordionDetails style={{ overflowX: 'scroll', padding: '0' }}>
          {expanded && <ContentAccordion userId={user_id} />}
        </AccordionDetails>
      </AccordionStyled>

      <ModalPause
        open={openModalPause}
        onClose={onClose}
        dataSeparator={separator}
        refreshDashboard={refreshDashboard}
        lastWork={last_work}
      />
    </animated.div>
  )
}

export default Accordion
